// Regra única de "pode editar?" do Disparador, espelhando o backend
// (BroadcastsController#broadcast_update_payload):
//   - pendente  → edição completa;
//   - template recorrente (recorrente e sem parent_broadcast_id) ativo ou
//     pausado → edita o template: as próximas execuções usam a nova versão.
// Antes o front só aceitava `pending`, então uma campanha recorrente ativa
// não tinha como ser corrigida — só cancelando e recriando.
const ACTIVE_TEMPLATE_STATUSES = ['running', 'paused'];

export const isRecurringTemplate = broadcast =>
  broadcast?.start_mode === 'recurring' && !broadcast?.parent_broadcast_id;

export const isActiveRecurringTemplate = broadcast =>
  isRecurringTemplate(broadcast) &&
  ACTIVE_TEMPLATE_STATUSES.includes(broadcast?.status);

export const isBroadcastEditable = broadcast =>
  broadcast?.status === 'pending' || isActiveRecurringTemplate(broadcast);
